import { DataTypes, DataVariants, DataCardinalities } from "../../../data/DataManager";
import { GridRenderSlots } from "../../../grid/AgGridManager";
import { InputTypes, Widths } from "../../../form/FormManager";
import { EMPTY_VALUE, FieldSchema, FieldValues } from "../../../Schema";
import { Tag } from "../../common/external-sources/Tags";
import { SchemaContext } from "../../common";

export const TAGS_MAX_COUNT = 10;
export const TAG_MAX_LENGTH = 20;
export const TAGS_LIMIT_MESSAGE =
  `You can add/select max of ${TAGS_MAX_COUNT} tags and each tag of ${TAG_MAX_LENGTH} characters max`;

export const validateTags = ({ tags }: FieldValues) => {
  if (!Array.isArray(tags)) {
    return EMPTY_VALUE;
  }
  const tooMany = tags.length > TAGS_MAX_COUNT;
  const tooLong = tags.some((tag) => typeof tag !== "string" || tag.length > TAG_MAX_LENGTH);
  return tooMany || tooLong ? TAGS_LIMIT_MESSAGE : EMPTY_VALUE;
};

export const createTags = (context: SchemaContext): FieldSchema => ({
  name: "tags",
  grid: {
    displayed: true,
    order: 54,
    render: GridRenderSlots.TAGS,
    sortable: false,
  },
  data: {
    type: DataTypes.ARRAY,
    variant: DataVariants.ENUM,
    options: context.tags.map((tag: Tag) => ({ value: tag.filterValue, label: tag.filterValue })),
    allowUnlisted: true,
    cardinality: DataCardinalities.MULTIPLE,
    maxCount: TAGS_MAX_COUNT,
  },
  display: {
    displayed: true,
  },
  validation: {
    custom: {
      getter: validateTags,
      fields: ["tags"],
    },
  },
  form: {
    label: "Tags",
    type: InputTypes.MULTISELECT,
    helperText: "You can add/select maximum of 10 tags",
    width: Widths.DOUBLE,
  },
});
